import { render } from "./DeviceSetupAlert.vue?vue&type=template&id=04b0e13b&scoped=true"
import script from "./DeviceSetupAlert.vue?vue&type=script&lang=js"
export * from "./DeviceSetupAlert.vue?vue&type=script&lang=js"

import "./DeviceSetupAlert.vue?vue&type=style&index=0&id=04b0e13b&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b0e13b"]])

export default __exports__